import { Link } from "react-router-dom";

export default function Footer() {
    return <footer className="iost-main inner-wallet-footer">

        <section className="footer-nav ">
            <div className="container">
                <div className="row  fade-item" style={{ transform: "translate(0px, 0px)", opacity: 1, visibility: "inherit" }}>
                    <div className="col-lg-12">
                        <div className="item">
                            <h6>
                                Description
                            </h6>
                            <p>
                                IOST Wallet is an institution-grade, digital asset wallet for professionals. Combining robust security protocols, intuitive user interface, and multi-chain support, IOST Wallet allows you to enjoy the best features of cold and hot wallets.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div className="footer-copyright">
            <div className="container">

                <div className="row">
                    <div className="col-lg-12">
                        <p>© 2022 - 2025 IOS Foundation <Link to="/terms">Privacy Policy · Terms of Use</Link></p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
}